import { api } from './axios'

/**
 * Billing (Phase 7) endpoints.
 *
 * Bill totals are computed server-side:
 *   medicine_charge = Σ(item.quantity × current drug MRP)
 *   total           = service_charge + medicine_charge
 *   balance         = total - paid
 *
 * Creating a bill atomically dispenses stock for every item. Cancelling a bill
 * restores the stock. Frontend never tries to do these calculations itself —
 * we always re-fetch the bill after mutation.
 */
export const billingApi = {
  create: (payload) => api.post('/bills', payload).then((r) => r.data),

  list: ({ patient_id, status, date_from, date_to, limit = 50, offset = 0 } = {}, opts = {}) =>
    api
      .get('/bills', {
        params: { patient_id, status, date_from, date_to, limit, offset },
        ...opts,
      })
      .then((r) => r.data),

  get: (bill_id) => api.get(`/bills/${bill_id}`).then((r) => r.data),

  updatePayment: (bill_id, { paid }) =>
    api.patch(`/bills/${bill_id}/payment`, { paid }).then((r) => r.data),

  /** Mark a bill cancelled. Server restores stock. Idempotent. */
  cancel: (bill_id) => api.post(`/bills/${bill_id}/cancel`).then((r) => r.data),

  listForPatient: (patient_id, opts = {}) =>
    api.get(`/patients/${patient_id}/bills`, opts).then((r) => r.data),
}
